import React from 'react';
import { FormattedMessage } from 'react-intl';

export const tmpScreenEvents = [
    {
        count: 63,
        category: 'screen_map',
        action: 'click_button',
        label: 'Débuter',
    },
    {
        count: 10,
        category: 'screen_map',
        action: 'click_close',
        label: 'Close icon',
    },
    {
        count: 144,
        category: 'screen_map',
        action: 'click_marker_open',
        label: '1 - Un marqueur',
    },
    {
        count: 124,
        category: 'screen_map',
        action: 'click_marker_close',
        label: '1 - Un marqueur',
    },
    {
        count: 44,
        category: 'screen_map',
        action: 'click_marker_open',
        label: '2 - Un autre marqueur',
    },
    {
        count: 24,
        category: 'screen_map',
        action: 'click_marker_close',
        label: '2 - Un autre marqueur',
    },
    {
        count: 1,
        category: 'screen_map',
        action: 'drag_map',
        label: 'Latitude: 45.4809, Longitude: -73.7461',
    },
    {
        count: 1,
        category: 'screen_map',
        action: 'drag_map',
        label: 'Latitude: 44.4809, Longitude: -72.7461',
    },
    {
        count: 4,
        category: 'viewer_menu',
        action: 'click_open',
        label: 'Menu icon',
    },
    {
        count: 4,
        category: 'viewer_menu',
        action: 'click_close',
        label: 'Close icon',
    },
    {
        count: 1,
        category: 'viewer_menu',
        action: 'click_share',
        label: 'Facebook',
    },
    {
        count: 2,
        category: 'viewer_menu',
        action: 'click_screen_change',
        label: 'Screen 1',
    },
    {
        count: 1,
        category: 'viewer_menu',
        action: 'click_screen_change',
        label: 'Screen 2',
    },
];

const formattedActions = {
    click: {
        formatted: <FormattedMessage defaultMessage="Clicked" description="Click tracking label" />,
    },
    click_submit: {
        formatted: (
            <FormattedMessage
                defaultMessage="Clicked on submit button"
                description="Click submit tracking label"
            />
        ),
    },
    click_answer: {
        formatted: (
            <FormattedMessage
                defaultMessage="Clicked on answer"
                description="Click answer tracking label"
            />
        ),
    },
    click_button: {
        formatted: (
            <FormattedMessage
                defaultMessage="Clicked on button"
                description="Click button tracking label"
            />
        ),
    },
    click_close: {
        formatted: (
            <FormattedMessage
                defaultMessage="Clicked on close button"
                description="Click close tracking label"
            />
        ),
    },
    click_marker_open: {
        formatted: (
            <FormattedMessage
                defaultMessage="Opened a marker"
                description="Click marker open tracking label"
            />
        ),
    },
    click_marker_close: {
        formatted: (
            <FormattedMessage
                defaultMessage="Closed a marker"
                description="Click marker close tracking label"
            />
        ),
    },
    drag_map: {
        formatted: (
            <FormattedMessage defaultMessage="Map dragged" description="Drag map tracking label" />
        ),
        groupLabels: true,
    },
    drag_sphere: {
        formatted: (
            <FormattedMessage
                defaultMessage="Video sphere dragged"
                description="Drag sphere tracking label"
            />
        ),
    },
    submit_success: {
        formatted: (
            <FormattedMessage
                defaultMessage="Successfully submitted content"
                description="Submit success tracking label"
            />
        ),
        groupLabels: true,
    },
    input_filled: {
        formatted: (
            <FormattedMessage
                defaultMessage="Input field filled"
                description="Input filled tracking label"
            />
        ),
    },
    scroll: {
        formatted: (
            <FormattedMessage defaultMessage="Content scrolled" description="Scroll tracking label" />
        ),
    },
    play: {
        formatted: <FormattedMessage defaultMessage="Played" description="Play tracking label" />,
    },
    pause: {
        formatted: <FormattedMessage defaultMessage="Paused" description="Pause tracking label" />,
    },
    resume: {
        formatted: <FormattedMessage defaultMessage="Resumed" description="Resume tracking label" />,
    },
    ended: {
        formatted: <FormattedMessage defaultMessage="Ended" description="Ended tracking label" />,
    },
    mute: {
        formatted: <FormattedMessage defaultMessage="Muted" description="Mute tracking label" />,
    },
    unmute: {
        formatted: <FormattedMessage defaultMessage="Unmuted" description="Unmute tracking label" />,
    },
    seek: {
        formatted: <FormattedMessage defaultMessage="Seeked" description="Seek tracking label" />,
    },
    'progress_10%': {
        formatted: (
            <FormattedMessage
                defaultMessage="10% of media played"
                description="Progress 10% tracking label"
            />
        ),
    },
    'progress_25%': {
        formatted: (
            <FormattedMessage
                defaultMessage="25% of media played"
                description="Progress 25% tracking label"
            />
        ),
    },
    'progress_50%': {
        formatted: (
            <FormattedMessage
                defaultMessage="50% of media played"
                description="Progress 50% tracking label"
            />
        ),
    },
    'progress_75%': {
        formatted: (
            <FormattedMessage
                defaultMessage="75% of media played"
                description="Progress 75% tracking label"
            />
        ),
    },
    'progress_90%': {
        formatted: (
            <FormattedMessage
                defaultMessage="90% of media played"
                description="Progress 90% tracking label"
            />
        ),
    },
    viewer_menu_click_open: {
        formatted: (
            <FormattedMessage
                defaultMessage="Opened menu"
                description="Viewer open menu tracking label"
            />
        ),
    },
    viewer_menu_click_close: {
        formatted: (
            <FormattedMessage
                defaultMessage="Closed menu"
                description="Viewer close menu tracking label"
            />
        ),
        ignore: true,
    },
    viewer_menu_click_screen_change: {
        formatted: (
            <FormattedMessage
                defaultMessage="Screen changed"
                description="Change screen tracking label"
            />
        ),
        groupLabels: true,
    },
    viewer_menu_click_share: {
        formatted: (
            <FormattedMessage
                defaultMessage="Story shared"
                description="Share story tracking label"
            />
        ),
    },
};

const getMatchingTrackingAction = (trackingEvent) => {
    const { category = null, action = null } = trackingEvent || {};
    const isViewerMenu = category === 'viewer_menu';
    const checkKey = isViewerMenu ? `${category}_${action}` : action;
    return typeof formattedActions[checkKey] !== 'undefined'
        ? { key: checkKey, content: formattedActions[checkKey] }
        : null;
};

const getFormattedTrackingEvents = (trackingEvents) => {
    const groupedCount = trackingEvents.reduce((groups, item, index) => {
        const { count = 0 } = item || {};
        const { key = null, content = null } = getMatchingTrackingAction(item) || {};
        if (key !== null) {
            const { groupLabels = false } = content || {};
            if (groupLabels) {
                const group = groups[key];
                if (typeof group === 'undefined') {
                    return { ...groups, [key]: { count, index } };
                }
                return { ...groups, [key]: { ...group, count: group.count + count } };
            }
        }
        return groups;
    }, {});

    const groupedItems = trackingEvents.filter((item, itemIndex) => {
        const { key = null, content = null } = getMatchingTrackingAction(item) || {};
        if (key !== null) {
            const { groupLabels = false } = content || {};
            if (groupLabels) {
                const group = groupedCount[key];
                return typeof group !== 'undefined' && group.index === itemIndex;
            }
        }
        return true;
    });

    const mergedGroupItems = groupedItems.map((item) => {
        const { key = null } = getMatchingTrackingAction(item) || {};
        if (key !== null) {
            const group = groupedCount[key];
            if (typeof group !== 'undefined') {
                return {
                    ...item,
                    count: group.count,
                    label: (
                        <>
                            (
                            <FormattedMessage
                                defaultMessage="Multiple"
                                description="Multiple tracking label"
                            />
                            )
                        </>
                    ),
                };
            }
        }
        return item;
    });

    mergedGroupItems.sort((a, b) => (a.count > b.count ? -1 : 1));

    const formattedItems = mergedGroupItems.map((item) => {
        const { action = null, label = null, count = null } = item || {};
        const formattedContent = {
            action,
            label,
            count,
        };
        const { content = null } = getMatchingTrackingAction(item) || {};
        const { formatted: formattedAction = null } = content || {};

        if (formattedAction !== null) {
            formattedContent.action = formattedAction;
        }
        return formattedContent;
    });

    return formattedItems;
};

export default getFormattedTrackingEvents;
